import PropTypes from 'prop-types';
import './styles.css';

const BudgetProgress = ({ percentage, state, label }) => {
  const safePercentage = Number.isFinite(percentage) ? Math.max(0, percentage) : 0;
  const visualPercentage = Math.min(100, safePercentage);

  return (
    <div
      className={`nf-budget-progress nf-budget-progress--${state}`}
      role="progressbar"
      aria-label={label}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow={Math.round(safePercentage)}
    >
      <span style={{ '--nf-budget-progress-value': `${visualPercentage}%` }} />
    </div>
  );
};

BudgetProgress.propTypes = {
  percentage: PropTypes.number.isRequired,
  state: PropTypes.oneOf(['empty', 'normal', 'warning', 'reached', 'exceeded']).isRequired,
  label: PropTypes.string.isRequired,
};

export default BudgetProgress;
